const axios = require('axios');

import {SANTE_URL as baseUrl } from "src/modules/shared/config/config.service"

const TarificationSanteService = {
    /**
     * Récupère les paramètres de configuration pour la tarification
     */
    getParameters() {
        const url = baseUrl + `/tarificateur/parameters`
        return axios.get(url)
    },
    /**
     * Récupère le prix de la combinaison demandée
     */
    getPrice(combinaison) {
        const url = baseUrl + `/devis/priceAjax/combinaison/` + combinaison
        return axios.get(url).then(res => res.data.price)
    },
    /**
     * Renvoie l'URL du tableau de garantie
     */
    returnWarrantyTablePdfUrl(combinaison) {
        return baseUrl + '/devis/pdfGaranties/combinaison/' + combinaison
    },
    /**
     * Soumets la tarification choisie
     */
    submitForm(data, params) {
        const url = baseUrl + '/tarificateur/submit'
        return axios.post(url, data, {params: params})
    },
    /**
     * Mets à jour le consentement
     */
    updateConsentement(data) {
        const url = baseUrl + '/tarificateur/consentement'
        return axios.post(url, data)
    },
}

export default TarificationSanteService
